/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GetService, PostFormData } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import BounceLoader from "react-spinners/BounceLoader";
import { toastEmmit } from "../../../Helper/Toastr";
// import 'intl-tel-input/build/css/intlTelInput.css';
// import intlTelInput from 'intl-tel-input';

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function MyProfile({ SendUpdateData }) {
  let [loading, setLoading] = useState(true);
  const [UpdatedData, setUpdatedData] = useState("");
  // const [selectedCountryCode, setselectedCountryCode] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    setLoading(true);
    GetService(API_URL.MY_PROFILE).then(
      (res) => {
        console.log(res);
        setLoading(false);
        if (res.data?.status === true) {
          const profileData = {
            fullName: res.data?.data?.fullName,
            email: res.data?.data?.email,
            contactNo: res.data?.data?.phone,
            profile: res.data?.data?.profile ||"",
            country: res.data?.data?.country || "",
            // password: "",
          };
          formik.setValues(profileData);
          setPhoneNumber(res.data?.data?.phone);
          setUpdatedData(res.data?.data);
          SendUpdateData(res.data?.data);
          localStorage.setItem("profile", res?.data?.data?.profile ||"");
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  // const phoneInputRef = useRef(UpdatedData?.contactNo);

  // useEffect(() => {
  //   if(UpdatedData){
  //   const input = phoneInputRef.current;
  // console.log(input)
  //   if (input) {
  //     const iti = intlTelInput(input, {
  //       separateDialCode: true,
  //       preferredCountries: ['us', 'gb'],
  //       // ... other options
  //     });

  //     input.addEventListener('countrychange', function () {
  //       const selectedCountryData = iti.getSelectedCountryData();
  //       setselectedCountryCode(selectedCountryData)
  //     });

  //     const defaultCountry = UpdatedData?.country;
  //     if (defaultCountry) { // Add a check for the existence of UpdatedData?.country
  //       iti.setCountry(defaultCountry);
  //     }

  //     return () => {
  //       if(iti){
  //         iti.destroy();
  //       }
  //     };
  //   }
  // }
  // }, [phoneInputRef.current,UpdatedData]);

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Full Name is required"),
    // email: Yup.string()
    //   .email("Invalid email address")
    //   .required("Email is required"),
    contactNo: Yup.string().required("Contact No is required"),
    // password:
    //   UpdatedData?.userType === "guestLogin"
    //     ? Yup.string().required("Password is required")
    //     : "",
  });

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      contactNo: "",
      profile: "",
      country: "",
      // password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);

      setLoading(true);
      const Formdata = new FormData();
      Formdata.append("fullName", values.fullName);
      Formdata.append("email", values.email);
      Formdata.append("phone", values.contactNo);
      // Formdata.append("phone_dialCode", selectedCountryCode?.dialCode);
      // Formdata.append("country", selectedCountryCode?.iso2);
      Formdata.append("country", values.country);
      Formdata.append("user_profile", values.profile);
      // if (UpdatedData?.userType === "guestLogin") {
      //   Formdata.append("password", values.password);
      // }

      PostFormData(API_URL.UPDATE_PROFILE, Formdata).then((res) => {
        console.log(res);
        setLoading(false);
        if (res.data?.status === true) {
          localStorage.setItem("user", res?.data?.data?.fullName);
          localStorage.setItem("profile", res?.data?.data?.profile);
          toastEmmit("success", res?.data?.message);
          SendUpdateData(res.data.data);
          // const updatedImage = res.data;
          // setUpdatedImageUrl(updatedImage);
          // onUpdateImage(updatedImage);
        }
      });
    },
  });

  useEffect(() => {
    // console.log(phoneNumber);
    formik.setFieldValue("contactNo", phoneNumber);
  }, [phoneNumber]);

  return (
    <>
      {!loading && (
        <div
          className="tab-pane fade active show"
          id="nav-Brochure"
          role="tabpanel"
          aria-labelledby="nav-Brochure-tab"
          tabIndex={0}
        >
          <div className="tp-best-product-4__item-box">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-6">
                <div className="heading">
                  <p>My Profile</p>
                </div>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className=" input">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="tp-contact-4__input-box mb-20">
                          <label htmlFor="fullName">
                            Full Name<sup className="error">*</sup>
                          </label>
                          <input
                            type="text"
                            name="fullName"
                            placeholder="Full Name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fullName}
                          />
                          {formik.touched.fullName && formik.errors.fullName ? (
                            <div className="error">
                              {formik.errors.fullName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="tp-contact-4__input-box mb-20">
                          <label htmlFor="email">
                            Email<sup className="error">*</sup>
                          </label>
                          <input
                            type="text"
                            name="email"
                            placeholder="Email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            className={
                              UpdatedData?.userType === "guestLogin"
                                ? "disabled"
                                : "disabled"
                            }
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <div className="error">{formik.errors.email}</div>
                          ) : null}
                        </div>
                      </div>

                      {/* {UpdatedData &&
                        UpdatedData?.userType === "guestLogin" && (
                          <div className="col-xl-6 col-lg-6 col-md-6">
                            <div className="tp-contact-4__input-box mb-20">
                              <label>
                                Password<sup className="error">*</sup>
                              </label>
                              <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Enter Your password"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.password}
                              />
                              <i
                                className={
                                  showPassword
                                    ? "fa-regular fa-eye"
                                    : "fa-regular fa-eye-slash"
                                }
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  cursor: "pointer",
                                  top: "50px",
                                  right: "25px",
                                  position: "absolute",
                                }}
                              />
                              {formik.touched.password &&
                              formik.errors.password ? (
                                <div className="error mt-1">
                                  {formik.errors.password}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        )} */}
                        
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="tp-contact-4__input-box mb-20 height-4">
                          <label>
                            Contact No<sup className="error">*</sup>
                          </label>{" "}
                          <br />
                          <PhoneInput
                            country={"us"}
                            value={phoneNumber}
                            onChange={(e, country) => {
                              const formattedNumber = `+${e.replace(
                                /\D/g,
                                ""
                              )}`;
                              setPhoneNumber(formattedNumber);
                              formik.setFieldValue("country", country?.name);
                              // console.log(e,formattedNumber)
                              // console.log(country)
                            }}
                          />
                          {/* <input
                            ref={phoneInputRef}
                            type="tel"
                            name="contactNo" 
                            placeholder="Contact No"
                            style={{ paddingLeft: 82 }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.contactNo} 
                          /> */}
                          {formik.touched.contactNo &&
                          formik.errors.contactNo ? (
                            <div className="error">
                              {formik.errors.contactNo}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="tp-contact-4__input-box mb-20">
                          <label htmlFor="profile">Profile Image</label>
                          <input
                            type="file"
                            name="profile"
                            onChange={(event) => {
                              const selectedFile = event.target.files[0];
                              formik.setFieldValue("profile", selectedFile);
                            }}
                            onBlur={formik.handleBlur}
                            className="pt-1 px-4"
                          />
                          {/* {formik.touched.profile && formik.errors.profile ? (
                       <div className="error">{formik.errors.profile}</div>
                     ) : null} */}
                        </div>
                      </div>
                    </div>
                    <div className="tp-contact-4__input-box mb-30 mt-60">
                      <button type="submit" className="tp-btn-lg large head">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
